export default "__VITE_ASSET__44f242f4__"